import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import Grid, { Row, Col } from 'hb-react/shared/components/DesignSystem/Grid';

import TopicsCategory from './TopicsCategory';
import TopicsSuperCategoryBreadcrumb from './TopicsSuperCategoryBreadcrumb';
import { SUPER_CATEGORY } from '../constants/types';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import useTopicsCategories from '../hooks/useTopicsCategories';

const TopicsCategories = () => {
  const { currentView, selectedSuperCategory } = useTopicsIndexContext();
  const { categories, totalCategories, isFetchingCategories, loadNextPage } =
    useTopicsCategories();

  return (
    <Box data-testid="topics-categories-list" display="block" width="100%">
      <Box flexDirection="column">
        {currentView === SUPER_CATEGORY && selectedSuperCategory && (
          <Grid mb={6}>
            <Row>
              <Col>
                <TopicsSuperCategoryBreadcrumb />
              </Col>
            </Row>
          </Grid>
        )}
        {categories.length > 0 ? (
          <>
            {categories.map((category) => (
              <TopicsCategory key={category.id} category={category} />
            ))}
            {totalCategories > 0 && categories.length < totalCategories && (
              <Grid
                width="100%"
                minWidth={0}
                height="fit-content"
                mb={6}
                ml={0}
              >
                <Row>
                  <Col width={12 / 12}>
                    <Box flex={1} justifyContent="center">
                      <Button
                        onClick={loadNextPage}
                        isLoading={isFetchingCategories}
                      >
                        {__('Load More')}
                      </Button>
                    </Box>
                  </Col>
                </Row>
              </Grid>
            )}
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default TopicsCategories;
